import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import {
  DeleteExporterMutation,
  DeleteExporterMutationVariables,
} from '../../../shared/generated/graphql';

export const DELETE_EXPORTER = gql`
  mutation deleteExporter($exporter_id: ExporterIdInput!) {
    deleteExporter(exporter_id: $exporter_id)
  }
`;

export const useDeleteExporter = (
  options: MutationHookOptions<
    DeleteExporterMutation,
    DeleteExporterMutationVariables
  >,
) => {
  return useMutation<DeleteExporterMutation, DeleteExporterMutationVariables>(
    DELETE_EXPORTER,
    options,
  );
};
